import { httpPublic2 } from "@/api/public";

export const trackingRequests = {
  email: function ({ context, data } = {}) {
    return httpPublic2.post("/v1/tracking/email", { context, json: data }).json();
  },
};
